"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var separator = '-';
var regex1 = /([a-z\d])([A-Z])/g;
var regex2 = /([a-z]+)([A-Z][a-z\d]+)/g;

function decamelize(text) {
  return text.replace(regex1, "$1".concat(separator, "$2")).replace(regex2, "$1".concat(separator, "$2")).toLowerCase();
}

exports["default"] = decamelize;